<template>
    <div>
        <div style="font-weight: bold; font-size: medium" class="widget-legend legend">Taxon Search Results</div>
        <div class="summary-text">
            <div style="background-color: #ccced2; font-weight: bold; font-size: medium"
                 class="pt-1 pb-1  pl-2 bg-info text-white">Search Criteria
            </div>
            <div class="container">
                <div class="row">
                    <div class="col">
                        <span>Dataset: </span> {{ this.matches.dataset }}
                    </div>
                </div>
                <div class="row">
                    <div class="col">
                        <span>From: </span> : {{ this.matches.start_date }}
                    </div>
                    <div class="col">
                        <span>To: </span> : {{ this.matches.end_date }}
                    </div>
                </div>
                <div class="row">
                    <div class="col">
                        <span>Taxon: </span> {{ this.matches.taxon }}
                    </div>
                    <div class="col">
                        <span>Rank: </span> {{ this.matches.rank }}
                    </div>
                </div>
            </div>
            <div style="background-color: #ccced2; font-weight: bold; font-size: medium"
                 class="pt-1 pb-1  pl-2 bg-info text-white">Matches
            </div>
            <div class="container">
                <div class="row">
                    <div class="col">
                        <span>Taxa: </span> {{ this.matches.taxons }}
                    </div>
                    <div class="col">
                        <span>Sequences: </span> {{ this.matches.sequences }}
                        <span v-if="this.matches.sequences > 0" class="col">
              <a href="# " v-on:click="exportSequenceAsFasta"><b-badge class="badge-info">Export Fasta</b-badge></a>
            </span>
                    </div>
                </div>
            </div>
            <div style="background-color: #ccced2; font-weight: bold; font-size: medium"
                 class="pt-1 pb-1 pl-2 bg-info text-white"> Dataset Info
            </div>
            <div class="container">
                <div class="row">
                    <div class="col">
                        <span>Campaign: </span> {{ this.matches.campaign }}
                    </div>
                    <div class="col" v-if="this.matches.marker">
                        <span>Marker: </span> {{ this.matches.marker }}
                    </div>
                </div>
                <div class="row" v-if="this.matches.project">
                    <div class="col">
                        <span>Project: </span> {{ this.matches.project }}
                    </div>
                </div>
                <div class="row" v-if="this.matches.doi">
                    <div class="col">
                        <span>DOI: </span> {{ this.matches.doi }}
                    </div>
                </div>
            </div>
            <div style="background-color: #ccced2; font-weight: bold; font-size: medium"
                 class="pt-1 pb-1 pl-2 bg-info text-white">
                Taxonomy Info
            </div>
            <div class="container">
                <div class="row">
                    <div class="col">
                        <span>Name: </span>{{ this.matches.taxonomy_name }}
                    </div>
                    <div class="col">
                        <span>Version: </span> {{ this.matches.taxonomy_version }}
                    </div>
                </div>
            </div>

            <div style="background-color: #ccced2; font-weight: bold; font-size: medium"
                 class="pt-1 pb-1 pl-2 bg-info text-white"> Sampling Info
            </div>
            <div class="container">
                <div class="row">
                    <div class="col ">
                        <span>Events: </span>{{ this.matches.samples }}
                    </div>
                    <div class="col">
                        <span>Sites: </span> {{ this.matches.sites }}
                    </div>
                    <div class="col">
                        <span>Depth Classes: </span> {{ this.matches.depths }}
                    </div>

                </div>
            </div>
            <div style="background-color: #ccced2; font-weight: bold; font-size: medium"
                 class="pt-1 pb-1 pl-2 bg-info text-white">
                Clustering
            </div>
            <div class="container">

                <table class="table-striped">
                    <thead>
                    <tr>
                        <th class="col-2">Name</th>
                        <th class="">Stations</th>

                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="cluster in this.matches.clusters" v-bind:key="cluster">
                        <th class="">{{ cluster.cluster_name }}</th>
                        <th class=""> {{ cluster.related_stations }}</th>
                    </tr>
                    </tbody>
                </table>
            </div>
            <br>
        </div>
    </div>
</template>

<script>
import axios from "axios";
import {mapActions} from "vuex"
import {saveAs} from 'file-saver';
import {ApiCall} from "../mixins/ApiMixin";

export default {
    name: "SummaryWidget",
    props: ['panelId', 'componentId', 'triggerValue', 'settings'],
    mixins: [ApiCall],

    data() {
        return {
            dataset: null,

            rank: null,
            searchPanelTaxon: null,

            dateStart: null,
            dateEnd: null,
            matches: {},

            settingsHash: "",
        }
    },

    created() {
        this.updateContents()
    },


    watch: {
        triggerValue() {
            this.updateContents()
        },

    },

    methods: {

        ...mapActions([
            'updateDashboardWidgetSettings',
        ]),

        updateContents() {
            let panel = this.$store.state.panels[this.panelId]
            this.dataset = panel.dataset
            this.rank = panel.rank
            this.taxon = panel.taxon
            this.dateStart = panel.dateStart
            this.dateEnd = panel.dateEnd
            this.getInfoDataset()

        },

        exportSequenceAsFasta() {
            let me = this
            me.apiCallsInProgress++
            axios
                .get(this.sanitizeApiCall(this.$store.state.apiRootPath,['sequences_as_fasta',
                this.dataset,this.taxon]))
                .then(function (response) {
                    let sequences = response.data
                    let blob_txt = new Blob([sequences], {type: "text/plain;charset=utf-8"})
                    saveAs(blob_txt, me.dataset + me.rank + me.taxon + "_sequence.fasta")
                    me.apiCallsInProgress--
                })

        },

        getInfoDataset() {
            if (this.dataset && this.rank && this.taxon) {
                let newSettingsHash = this.dataset + this.rank + this.taxon

                if (newSettingsHash === this.settingsHash) {
                    return
                }
                this.updateDashboardWidgetSettings({
                    'componentId': this.componentId,
                    'settings': {
                        'dataset': this.dataset,
                        'rank': this.taxon,
                        'taxon': this.taxon,
                    }
                })
                let me = this
                axios
                    .get(this.sanitizeApiCall(this.$store.state.apiRootPath,['matches_for_summary',
                    this.dataset, this.rank, this.taxon, this.dateStart, this.dateEnd]))
                    .then(response => (me.matches = response.data));
            } else {
                console.debug("geInfoDataset " + this.componentId + ": undefined parameters, no actual data  retrieval attempted.")
            }
        },
    }
}


</script>

<style scoped>
.summary-text {
    font-size: small;
    height: 100%;
}

span {
    font-weight: bold;
}

</style>